// extracted by mini-css-extract-plugin
export default {"root":"classes_root__32Si4","content":"classes_content__h1EGQ","image":"classes_image__8-St6","button-container":"classes_button-container__ipt1A","icon":"classes_icon__2Q3kD"};